var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5545 0H8.13783C4.11137 0 0.846161 3.26521 0.846161 7.29167V27.7083C0.846161 31.7348 4.11137 35 8.13783 35H28.5545C32.5824 35 35.8462 31.7348 35.8462 27.7083V7.29167C35.8462 3.26521 32.5824 0 28.5545 0ZM12.5128 27.7083H8.13783V11.6667H12.5128V27.7083ZM10.3253 9.8175C8.91658 9.8175 7.77324 8.66542 7.77324 7.245C7.77324 5.82458 8.91658 4.6725 10.3253 4.6725C11.7341 4.6725 12.8774 5.82458 12.8774 7.245C12.8774 8.66542 11.7355 9.8175 10.3253 9.8175ZM30.0128 27.7083H25.6378V19.5358C25.6378 14.6242 19.8045 14.996 19.8045 19.5358V27.7083H15.4295V11.6667H19.8045V14.2406C21.8403 10.4694 30.0128 10.1908 30.0128 17.8515V27.7083Z",
    fill: "#DCD7C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0.846161)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedIn);
export default __webpack_public_path__ + "static/media/footerLinkedIn.4b091eb56344bb166bedf6d732de55b4.svg";
export { ForwardRef as ReactComponent };